'use strict';

var _setup = require('./setup.js');

var $embed = $('<div id="nx-vidplayer-embed"></div>');
var $embedOuter = _setup.s.$videoOverlay.find('.nx-vidplayer--outer');

var plyr = null;
var embedded = false;

var openPlayerModal = function openPlayerModal(type, id, e) {
	e.preventDefault();
	if (!type || !id) {
		console.warn('A data attribute is missing, include video-type & video-id on modal buttons');
		return false;
	}

	_setup.s.$body.addClass('is-showing-overlay is-opening-overlay');

	if (embedded) {
		$embed = _setup.s.$videoOverlay.find('#nx-vidplayer-embed');
	} else {
		_setup.s.$videoEmbedTarget.prepend($embed);
		embedded = true;
	}

	$embed.attr({ 'data-type': type, 'data-video-id': id });

	plyr = window.plyr.setup($embed[0], {
		tooltips: { controls: false, seek: true },
		clickToPlay: false,
		hideControls: true,
		controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'fullscreen']
	});

	if (Modernizr.videoautoplay) {
		plyr[0].on('ready', function () {
			plyr[0].play();
			TweenMax.to($embedOuter, 0.75, { autoAlpha: 1, y: 0, scale: 1, delay: 0.25, ease: Expo.easeOut,
				onComplete: function onComplete() {
					return _setup.s.$body.removeClass('is-opening-overlay').addClass('is-video-playing');
				} });
		});
	} else {
		TweenMax.to($embedOuter, 0.75, { autoAlpha: 1, y: 0, scale: 1, delay: 0.25, ease: Expo.easeOut,
			onComplete: function onComplete() {
				return _setup.s.$body.removeClass('is-opening-overlay').addClass('is-video-playing');
			} });
	}

	plyr[0].on('ended', function () {
		return setTimeout(closePlayerModal, 250);
	});

	_setup.s.$videoOverlay.css({ minHeight: $embedOuter.height() + 'px' });

	TweenMax.set($embedOuter, { autoAlpha: 0, scale: 1.5 });
	TweenMax.to(_setup.s.$videoOverlay, 0.3, { autoAlpha: 1 });
};

var closePlayerModal = function closePlayerModal() {
	plyr[0].stop();
	plyr[0].destroy();
	plyr = null;

	_setup.s.$body.removeClass('is-video-playing');
	TweenMax.to(_setup.s.$videoOverlay, 0.2, { autoAlpha: 0, onComplete: function onComplete() {
			return _setup.s.$body.removeClass('is-showing-overlay');
		} });
};

if (_setup.s.$videoPlayBtns.length) {

	_setup.s.$videoPlayBtns.each(function (index, item) {
		var $this = $(item);
		var $parent = $this.parent('.nx-playbtn');

		if ($parent.length) {
			$this.hover(function () {
				return $parent.addClass('is-hovering');
			}, function () {
				return $parent.removeClass('is-hovering');
			});
		}
		$this.click(function (event) {
			return openPlayerModal($this.data('video-type'), $this.data('video-id'), event);
		});
	});

	_setup.s.$videoClose.click(function () {
		return closePlayerModal();
	});
}

if (_setup.s.$videoposters.length) {

	_setup.s.$videoposters.each(function (i, item) {
		var $this = $(item);
		$this.find('.nx--lazyload').on('nx.imgloaded', function () {
			return $this.addClass('is-imgloaded');
		});
	});
}


//////////////////
// WEBPACK FOOTER
// ./_js/video-players.js
// module id = 14
// module chunks = 0